import { BaseComponent } from '@/src/app/shared/components/base-component/base.component';
import { cleftPublicationsFullRoute, educationAndResearchFullRoute } from '@/src/app/utils/routing.utils';
import { Component } from '@angular/core';
import { covidResources, saqProtocolsResources } from '@/src/app/features/educational-resources/utils/educational-resources.utils';
import { ResourceSection } from '@src/app/features/educational-resources/models/resource.model';
import { DataBlockComponent } from '@shared/components/data-block/data-block.component';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { GenericResourceListComponent } from '../../../educational-resources/shared/generic-resource-list/generic-resource-list.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-dashboard-resources-panel',
  templateUrl: './dashboard-resources-panel.component.html',
  styleUrls: ['../dashboard-page/dashboard-page.component.scss'],
  imports: [DataBlockComponent, RouterLink, MatButton, GenericResourceListComponent, TranslateModule]
})
export class DashboardResourcesPanelComponent extends BaseComponent {
  readonly weeklyAbstractsRoute = `/${cleftPublicationsFullRoute}`;
  readonly educationAndResearchRoute = educationAndResearchFullRoute;
  readonly covidResources = covidResources;
  readonly saqProtocolsResources: ResourceSection[] = saqProtocolsResources;
}
